import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { isExist } from "cxa-utils";
import { getPropsFromData, InputField, RadioField, DATE_FORMAT_RHIHD201907 } from "../../FormField";

const Employee = ({ data }) => {
  return (
    <fieldset>
      <table className="employee-particulars hdf-form">
        <thead>
          <tr className="table-title">
            <th className="text--left" colSpan="5">
              A) PARTICULARS OF PROPOSED EMPLOYEE / ELIGIBLE MEMBER
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td width="50%" colSpan="2">
              <div style={{ display: "flex" }}>
                <div style={{ flexShrink: 0 }}>Name (as shown in NRIC / Passport)</div>
                <div style={{ marginLeft: 10 }}>
                  <RadioField
                    noDivWrapper={true}
                    label="Dr"
                    radioValue="Dr"
                    noErrorMsg={true}
                    {...getPropsFromData(data, "Salutation")}
                  />
                  <RadioField
                    noDivWrapper={true}
                    label="Mr"
                    radioValue="Mr"
                    noErrorMsg={true}
                    {...getPropsFromData(data, "Salutation")}
                  />
                  <RadioField
                    noDivWrapper={true}
                    label="Mrs"
                    radioValue="Mrs"
                    noErrorMsg={true}
                    {...getPropsFromData(data, "Salutation")}
                  />
                  <RadioField
                    noDivWrapper={true}
                    label="Miss"
                    radioValue="Miss"
                    {...getPropsFromData(data, "Salutation")}
                  />
                </div>
              </div>
            </td>
            <td width="17%">NRIC / Passport No.</td>
            <td width="17%">Date of Birth (dd/mm/yy)</td>
            <td width="16%">Age Next Birthday</td>
          </tr>
          <tr>
            <td id="RO_EmployeeName" colSpan="2">
              <InputField {...getPropsFromData(data, "EmployeeName")} />
            </td>
            <td id="RO_Identification">
              <InputField {...getPropsFromData(data, "Identification")} />
            </td>
            <td id="RO_BirthDate">
              <InputField
                {...getPropsFromData(data, "BirthDate")}
                format={value => isExist(value) && moment(value).format(DATE_FORMAT_RHIHD201907)}
              />
            </td>
            <td>
              <InputField {...getPropsFromData(data, "AgeNextBirthDay")} />
            </td>
          </tr>
          <tr>
            <td width="20%">Gender</td>
            <td width="30%">Marital Status</td>
            <td width="17%">Nationality</td>
            <td width="16%">Height (m)</td>
            <td width="16%">Weight (kg)</td>
          </tr>
          <tr>
            <td width="20%">
              <InputField {...getPropsFromData(data, "Gender")} />
            </td>
            <td width="30%">
              <InputField {...getPropsFromData(data, "MaritalStatus")} />
            </td>
            <td width="17%">
              <InputField {...getPropsFromData(data, "Nationality")} />
            </td>
            <td width="16%">
              <InputField {...getPropsFromData(data, "Height")} />
            </td>
            <td width="16%">
              <InputField {...getPropsFromData(data, "Weight")} />
            </td>
          </tr>
          <tr>
            <td colSpan="5">Name and Address of Employer</td>
          </tr>
          <tr>
            <td colSpan="5" id="RO_CompanyName">
              <InputField {...getPropsFromData(data, "CompanyName")} />
            </td>
          </tr>
          <tr>
            <td colSpan="2">Occupation</td>
            <td colSpan="3">Date of Employment (dd/mm/yy)</td>
          </tr>
          <tr>
            <td colSpan="2">
              <InputField {...getPropsFromData(data, "JobTitle")} />
            </td>
            <td colSpan="3" id="RO_JoinDate">
              <InputField
                {...getPropsFromData(data, "JoinDate")}
                format={value => isExist(value) && moment(value).format(DATE_FORMAT_RHIHD201907)}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </fieldset>
  );
};

Employee.propTypes = {
  data: PropTypes.object,
};

export default Employee;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/RHI/RHIHD201907/Employee.jsx